import store from '@/store';
import { getWithoutNilQuery } from '@/utils/path';
import { buildBuiltinFlowRedirect, mergeFlowRedirectQuery, } from './resolveAdvancedFlowPageRedirect';
export async function redirectBuiltinFlowToBoundPage(to) {
    const info = store.state.runtime?.aiProjectInfo ?? window.xy_runtime_ai_project_info;
    const resolved = buildBuiltinFlowRedirect(info, to);
    if (!resolved) {
        return null;
    }
    return {
        path: resolved.path,
        query: getWithoutNilQuery(mergeFlowRedirectQuery(to.query, resolved.query)),
        replace: true,
    };
}
